import React from 'react';
import Navbar from '../components/Navbar';
import ChatbotButton from '../components/ChatbotButton';
import '../styles/services.css'; // Make sure the CSS file has the correct styles

const ServicesPage = () => {
  const ministries = [
    { name: "Ministry of Health", image: "/images/government.png" },
    { name: "Ministry of Education", image: "/images/government.png" },
    { name: "Ministry of Finance", image: "/images/government.png" },
    { name: "Ministry of Interior", image: "/images/government.png" },
    { name: "Ministry of Foreign Affairs", image: "/images/government.png" },
    { name: "Ministry of Commerce", image: "/images/government.png"},
    { name: "Ministry of Transport", image: "/images/government.png" },
    { name: "Ministry of Agriculture", image: "/images/government.png" },
    { name: "Ministry of Tourism", image: "/images/government.png" },
    { name: "Ministry of Culture", image: "/images/government.png" },
    { name: "Ministry of Labor", image: "/images/government.png" },
    { name: "Ministry of Housing", image: "/images/government.png" }
  ];

  return (
    <div className="home-container">
      <Navbar />
      <h2>Ministries</h2>
      <div className="cards-container">
        {ministries.map((ministry, index) => (
          <div className="id-card-box" key={index}>
            <div className="id-card-previeww">
              <img src={ministry.image} alt={ministry.name} className="ministry-icon" />
              <strong>{ministry.name}</strong>
            </div>
          </div>
        ))}
      </div>
      <ChatbotButton />
    </div>
  );
};

export default ServicesPage;